export default __webpack_public_path__ + "static/media/grafema_pilates_09.d2add2fc.jpg";